import {
  HOTEL_HOVERED,
  SHOW_MORE,
  PAGINATION_SUCCESS,
  SET_CURRENT_VISIBLE_HOTELS,
} from './constants';

export const hotelHoverAction = (payload) => ({
  type: HOTEL_HOVERED,
  payload,
});

export const showMoreAction = (payload) => ({
  type: SHOW_MORE,
  payload,
});

export const paginationSuccessAction = (payload) => ({
  type: PAGINATION_SUCCESS,
  payload,
});
export const setCurrentVisibleHotelsAction = (payload) => ({
  type: SET_CURRENT_VISIBLE_HOTELS,
  payload,
});
